/** Currencies a player can choose for prices. EUR matches cached quotes. */
export const DISPLAY_CURRENCIES = [
  'EUR',
  'USD',
  'GBP',
  'CAD',
  'AUD',
  'NZD',
  'CHF',
  'SEK',
  'NOK',
  'DKK',
  'PLN',
  'JPY',
] as const;

export type DisplayCurrency = (typeof DISPLAY_CURRENCIES)[number];

export const DEFAULT_DISPLAY_CURRENCY: DisplayCurrency = 'EUR';

export function normalizeDisplayCurrency(value: unknown): DisplayCurrency {
  if (typeof value !== 'string') return DEFAULT_DISPLAY_CURRENCY;
  const code = value.trim().toUpperCase();
  if ((DISPLAY_CURRENCIES as readonly string[]).includes(code)) {
    return code as DisplayCurrency;
  }
  return DEFAULT_DISPLAY_CURRENCY;
}

/** "€ Euro (EUR)" for the settings menu. */
export function displayCurrencyLabel(code: string): string {
  const upper = code.trim().toUpperCase() || 'EUR';
  let name = upper;
  let symbol = upper;
  try {
    name = new Intl.DisplayNames('en', { type: 'currency' }).of(upper) ?? upper;
  } catch {
    name = upper;
  }
  try {
    symbol = new Intl.NumberFormat('en', {
      style: 'currency',
      currency: upper,
      currencyDisplay: 'narrowSymbol',
    })
      .formatToParts(0)
      .find((part) => part.type === 'currency')?.value ?? upper;
  } catch {
    symbol = upper;
  }
  return `${symbol} ${name} (${upper})`;
}
